// User Types used to identify the user

export const ORGANIZER = 'ORGANIZER';
export const ANONYMOUS = 'ANONYMOUS';
